export enum State {
    Traversing,
    Waiting,
}

export default State;
